import { authHeader, handleResponse } from '../helpers'

export const storyboardService = {
  getStoryboards,
  getStoryboard,
  createStoryboard,
  updateStoryboard,
  deleteStoryboard,
  getStoryboardsTemplate
}

function getStoryboards(eventId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/storyboards/' + eventId,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var storyboards = response.storyboards
      return storyboards
    })
}

function getStoryboardsTemplate(eventId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/storyboards/' + eventId + '/template',
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var storyboards = response.storyboards
      return storyboards
    })
}

function getStoryboard(storyboardId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/storyboard/' + storyboardId,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var storyboard = response
      return storyboard
    })
}

function createStoryboard(storyboardData) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: storyboardData
  }
  return fetch(process.env.VUE_APP_API_URL + '/storyboard', requestOptions)
    .then(handleResponse)
    .then((response) => {
      var storyboard = response
      return storyboard
    })
}

function updateStoryboard(storyboardId, storyboardData) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: storyboardData
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/storyboard/' + storyboardId,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var storyboard = response
      return storyboard
    })
}

function deleteStoryboard(storyboardId) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/storyboard/' + storyboardId,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var storyboard = response
      return storyboard
    })
}
